import { EditPointScreen } from "@/src/screens/edit-point-screen";

export default function EditPointRoute() {
  return <EditPointScreen />;
}
